/**
 * Formats the dismissible action object into a format that is easier to use.
 * Eg: Input : { 1: "A" }
 *     Output: { "A": 1 }
 */
const DismissibleActionStatus = (dismissibleActions: Record<any, any>): Record<any, any> =>
  Object.entries(dismissibleActions).reduce(
    (acc, [key, val]) => ({
      ...acc,
      [val]: key,
    }),
    {},
  );

export default DismissibleActionStatus;
